{
    "features-debit-card-explore-discounts": {
        "meta": {
            "title": "Explore Discounts - MAJORITY",
            "description": ""
        },
        "hero": {
            "title": "MAJORITY Discounts",
            "body": "Swipe with pride and save at any of our community discount partners. Spend less on groceries, restaurants, and more!"
        },
        "label": {
            "no_discount": "We’re getting more awesome discounts for you. Check back soon!"
        }
    }
}